// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container.light,\n.container-fluid.light {\n  background-color: #21324f;\n}\n.container.dark,\n.container-fluid.dark {\n  background-color: #1d2b44;\n}\n.container.h-100,\n.container-fluid.h-100 {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
